import { render, staticRenderFns } from "./product-modification.vue?vue&type=template&id=2e87e5b9&scoped=true&"
import script from "./product-modification.vue?vue&type=script&lang=js&"
export * from "./product-modification.vue?vue&type=script&lang=js&"
import style0 from "./product-modification.vue?vue&type=style&index=0&id=2e87e5b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e87e5b9",
  null
  
)

export default component.exports